import api from "./api";

// Search products by name (case-insensitive)
export const searchProducts = (name, page = 0, size = 6) => {
  return api.get(`/products/search`, {
    params: { name, page, size }
  });
};

// Get product by ID
export const getProductById = (id) => {
  return api.get(`/products/${id}`);
};

// Create product
export const createProduct = (data) => {
  return api.post(`/products`, data);
};

// Update product
export const updateProduct = (id, data) => {
  return api.put(`/products/${id}`, data);
};

// Delete product
export const deleteProduct = (id) => {
  return api.delete(`/products/${id}`);
};

const productService = {
  searchProducts,
  getProductById,
  createProduct,
  updateProduct,
  deleteProduct
};

export default productService;
